import {
  Component,
  
  OnInit,
  SimpleChanges,
  
  
} from '@angular/core';
import { isOptionActive } from '@dch/products-business-logic';

import { EnvironmentService } from '@proximus/ng-common';

import { OptionDetailsBackgroundService } from '../../option-details-background.service';
import { OrderButtonType } from '../../disney-plus-order-button/disney-plus-order-button.component';
import { Subscription } from 'rxjs';
import { getAlertKey } from 'src/app/shared/order-utils/order-utils';
import { SPORTS_PREMIUM_MPUID_CODES } from 'src/app/details/constants';

@Component({
  selector: 'mprd-sports-standard-premium',
  templateUrl: './sports-standard-premium.component.html',
})
export class SportsStandardPremiumComponent implements OnInit {
  public OrderButtonType = OrderButtonType;
  public isSubscriptionActive: boolean;
  public isPremiumPlanActive: boolean;
  public isStandardPlan: boolean;
  public isSportsProduct: boolean;
  public isScarletOption: boolean;

  public address: any;
  public alertKey: string;
  public netflixAlertKey: string;
  private readonly registerOptionParamsExecutedSubscription: Subscription;

  constructor(
    private readonly optionDetailsBackgroundService: OptionDetailsBackgroundService,
    protected environmentService: EnvironmentService,
  ) {
    // Guarantees that the option params are set here from OptionDetailsBackgroundService whithout using inputs

    this.registerOptionParamsExecutedSubscription =
      this.optionDetailsBackgroundService.registerOptionParamsExecutedSubject.subscribe(
        () => {
          this.initializeOptionParams();
        },
      );
  }
  ngOnInit() {
     this.initializeOptionParams();
  }

  ngOnChanges(changes: SimpleChanges): void {
      if (changes['option']) {
        this.initializeOptionParams();
      }
    }

  private initializeOptionParams() {
    const { option, selectedProduct } =
      this.optionDetailsBackgroundService.getOptionParams();
    this.initializeSubscriptionStatus(option);
    this.address = selectedProduct?.installationAddress;
    this.isSportsProduct =
      this.optionDetailsBackgroundService.isSportsProduct();
    this.isScarletOption =
      this.isSportsProduct &&
      this.optionDetailsBackgroundService.isScarletSportsProduct();
    this.alertKey = getAlertKey(undefined, option);
  }

  private initializeSubscriptionStatus(option: any) {
    this.isSubscriptionActive = isOptionActive(option);
    this.isPremiumPlanActive =
      this.isSubscriptionActive &&
      SPORTS_PREMIUM_MPUID_CODES.includes(option.optionCodeForDescription);
  }
}
